__turbopack_context__.v({
  "coinBox": "CoinInWalletAnim-module-scss-module__KBPU7W__coinBox",
  "enter": "CoinInWalletAnim-module-scss-module__KBPU7W__enter",
  "root": "CoinInWalletAnim-module-scss-module__KBPU7W__root",
  "wallet": "CoinInWalletAnim-module-scss-module__KBPU7W__wallet",
  "walletBox": "CoinInWalletAnim-module-scss-module__KBPU7W__walletBox",
  "walletCover": "CoinInWalletAnim-module-scss-module__KBPU7W__walletCover",
});
